import { NOTIFICATIONS } from "../lib/constants/actions";

export const sendNotification = (data) => {
    return { type: NOTIFICATIONS.SEND_NOTIFICATION, payload: data }
}

export const sendNotificationSuccess = (data) => {
    return { type: NOTIFICATIONS.SEND_NOTIFICATION_SUCCESS, payload: data }
}














